<script>

import CircleButton from "@/components/Common/Buttons/CircleButton.vue";
import MainButton from "@/components/Common/Buttons/MainButton.vue";


export default {
  components: {
    CircleButton,
    MainButton
  },
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    },
    placeholder: {
      type: String
    },
    placeholderCta: {
      type: Function
    },
    buttonText: {
      type: String
    },
    circleButton: {
      type: String
    },
    size: {
      type: String
    },
  },


};
</script>

<template>
  <div v-bind:class="{
    'title-size-small': size === 'small',
    'title-size-medium': size === 'medium'}">
    <div class="title-container d-md-flex align-items-center"
    >
      <div class="title"> {{ title }}</div>
      <div class="description"> {{ description }}</div>
      <div class="d-none d-md-flex ms-auto align-items-center">
        <div v-if="placeholder" class="subtitle me-auto"> {{ placeholder }}</div>
        <CircleButton v-if="placeholder" @click="placeholderCta" :theme="'solid-blue'"/>
        <router-link :to="{name: 'NewsView'} ">
          <div v-if="buttonText" class="me-auto title-button">
            <MainButton :button-text="buttonText" :icon="'arrow-forward'" :size="'large'" :theme="'solid-blue'"/>
          </div>
        </router-link>
      </div>

    </div>
  </div>


</template>

<style lang="scss" scoped>

.title-container {

  color: $color-brown;

  .description {
    margin: $spacing-2 0 $spacing-3 0;
    font-size: $paragraph-2;
    line-height: $paragraph-2;
    width: 90%;
  }

  .subtitle {
    font-size: $subtitle-1;
    width: 50%;
    line-height: 20px;
    text-align: right;
    color: $color-cta-main;
  }

}

.title-size-medium {
  .title-container {
    .title {
      font-family: $font-semi-bold;
      font-size: $title-h3;
      line-height: $title-h3;
    }

  }
}

.title-size-small {
  .title-container {
    padding: $spacing-3 0;

    .title {
      font-size: $title-h5;
      line-height: 1;
      font-family: $font-bold;

    }
  }
}


@media screen and (min-width: 768px) {

  .title-container {

    .description {
      width: 400px;
      margin: $spacing-1 0 $spacing-1 $spacing-4;
    }

    .description-bottom {
      margin-left: 50px;
      width: 25%;

    }

    .title-button {
      min-width: 300px;
    }

  }
  .title-size-medium {
    .title-container {
      padding: $spacing-8 0;

      .title {
        font-size: $title-h4;
        max-width: 350px;
        line-height: 1;
      }
    }
  }

  .title-size-small {
    .title-container {
      padding: $spacing-4 0;

      .title {
        font-size: $title-h3;
        font-family: $font-bold;

      }
    }
  }

}


</style>